import type { persons as kycAcceptance } from '@repo/api-kit/kyc-acceptance';
import type { KycResponse } from '@repo/api-kit/queries/due-diligence/kyc';

export function getFourthlineProviderDetails(
  kycInfo?: KycResponse
): kycAcceptance.firstparty.v1.ApiFourthlineProviderDetails | null {
  return kycInfo?.activeProcess?.providerDetails?.$case === 'fourthlineProviderDetails'
    ? kycInfo.activeProcess.providerDetails.value
    : null;
}
